import React from 'react';
import styled from '@emotion/styled';


export interface ImageProps {
  url: string;
}

interface ImageListProps {
  images: ImageProps[];
  onImageSelect: (index: number) => void;
  activeIndex: number;
}

const List = styled.ul`
  margin-left: 0;
  display: flex;
  white-space: nowrap;
  overflow-x: auto;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
`;

const Item = styled.li`
  padding: 0;
`;

const ImageWrapper = styled.div`
  width: 40px;
  height: 40px;
  margin: 0 2px;
  overflow: hidden;

  &.active {
    border: 1px solid #4a4a4a;
  }
`;

const Image = styled.img`
  max-width: 100%;
  padding: 0;
`;

const ImageList = ({ images, onImageSelect, activeIndex }: ImageListProps) => (
  <List>
    {
      images.map((image, index) => (
        <Item key={`thumb_${image.url || image}`} >
          <ImageWrapper className={(index === activeIndex) ? 'active' : ''} onClick={() => onImageSelect(index)}>
            <Image
              src={image.url || image}
              loading="lazy"
            />
          </ImageWrapper>
        </Item>
      ))
    }
  </List>
);

export default ImageList;
